/** Display label for the live 360 module (sidebar + page header). */
export const LIVE_NAME =
  String(process.env.REACT_APP_LIVE_NAME ?? "").trim();

function slugifyLiveName(name) {
  const slug = name
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
  return slug;
}

/** Route path for the live 360 page, e.g. `/live-360`. */
export const LIVE_PATH = `/${slugifyLiveName(LIVE_NAME)}`;

/** Previous default path — kept for bookmarks and old links. */
export const LEGACY_LIVE_PATH = `/${slugifyLiveName(LIVE_NAME)}`;
